import * as React from 'react';

import LearningPathBreadcrumbs from 'bundles/enterprise-learning-path-description-page/modules/LearningPathBreadcrumbs';
import type { EnterpriseLearningPathPageFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageFragments';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import BreadcrumbsModule from 'bundles/unified-description-page-common/components/modules/breadcrumbs/BreadcrumbsModule';

type Props = {
  pageData: EnterpriseLearningPathPageFieldsFragment;
};

const EnterpriseLearningPathBreadcrumbsModuleRenderer = ({ pageData }: Props) => {
  const program = useProgram();

  if (!program) {
    return null;
  }

  if (!pageData.enterpriseBadge) {
    return null;
  }

  return (
    <BreadcrumbsModule
      breadcrumbs={<LearningPathBreadcrumbs programName={program.name} programSlug={program.slug} />}
    />
  );
};

export default EnterpriseLearningPathBreadcrumbsModuleRenderer;
